var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('h1',[_vm._v("Create an account")]),_c('Register',{attrs:{"webinarRegister":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }